/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

require('../../normalize-component-d885d5ff.js');
var index = require('../../index-1651dbe5.js');

index.__vue_component__.install = function (Vue) {
  Vue.component(index.__vue_component__.name, index.__vue_component__);
};

module.exports = index.__vue_component__;
